<!--
 * @Description: 教学设计 查看 教学日志
 * @Author: ZSC
 * @Date: 2023-04-18 16:56:37.484
 * @LastEditors: PF
 * @LastEditTime: 2025-06-12 09:08:45
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">教学日志</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#ccc">
        <thead>
          <tr>
            <td bgcolor="#f4f4f5">班级</td>
            <td>{{ ruleForm.bjmc }}</td>
            <td bgcolor="#f4f4f5">课程名称</td>
            <td>{{ruleForm.kcmc}}（{{ ruleForm.skxsmc }}）</td>
            <td bgcolor="#f4f4f5">授课地点</td>
            <td class="w110">{{ ruleForm.jxcdmc }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td bgcolor="#f4f4f5">节次</td>
            <td colspan="1">星期{{ruleForm.xqmc}} - 第{{ruleForm.jc}}节（{{ruleForm.rq}} 第{{ruleForm.zc}}周）</td>
            <td bgcolor="#f4f4f5">教师教学计划</td>
            <td colspan="3">
              {{ ruleForm.xqjxjhbt }}
            </td>
          </tr>
          <tr v-for="(item,index) in ruleForm.jxrznrs" :key="index">
            <td bgcolor="#f4f4f5">{{item.mbzdmc}}</td>
            <td colspan="7" style="text-align: left;padding: 0 10px;">
              <!-- 文本 -->
              <span v-if="lxData.wenben === item.lx">{{ item.nr }}</span>
              <!-- 单选 -->
              <ul class="ml10 mr10" v-if="lxData.danxuan === item.lx" style="display: flex; flex-wrap: wrap;">
                <li v-for="(val,v) in item.jxrzxxnrs" :key="v" class="mr10">
                  <span v-if="val.sfmrz"><span style="font-size: 18px; margin-right: 5px;">☉</span>{{ val.xxnr }}</span>
                  <span v-else><span style="font-size: 18px; margin-right: 5px;">○</span>{{ val.xxnr }}</span>
                </li>
              </ul>
              <!-- 多选 -->
              <ul class="ml10 mr10" v-if="lxData.duoxuan === item.lx" style="display: flex; flex-wrap: wrap;">
                <li v-for="(val,v) in item.jxrzxxnrs" :key="v" class="mr10">
                  <span v-if="val.sfmrz"><span style="font-size: 18px; margin-right: 5px;">☑</span>{{ val.xxnr }}</span>
                  <div v-else style="display: flex;align-items: center;"><div style="margin-top: -9px;font-size: 24px; margin-right: 5px;">□</div>{{ val.xxnr }}</div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#CCCCCC">
        <thead>
          <tr>
            <td colspan="2"></td>
            <td :colspan="kqlxData.length" bgcolor="#ecf5ff">学生考勤</td>
            <td :colspan="jllxData.length" bgcolor="#ecf5ff">学生纪律</td>
            <td colspan="1"></td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="2" bgcolor="#f4f4f5">考勤汇总</td>
            <td v-for="(item, index) in xskqhz" :key="index">{{item.sl}}</td>
            <td v-for="(item, index) in xsjlhz" :key="index">{{item.sl}}</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td bgcolor="#f4f4f5">序号</td>
            <td bgcolor="#f4f4f5">姓名</td>
            <td bgcolor="#f4f4f5" v-for="(item, index) in kqlxData" :key="index">{{item.mbnr}}</td>
            <td bgcolor="#f4f4f5" v-for="(item, index) in jllxData" :key="index">{{item.mbnr}}</td>
            <td bgcolor="#f4f4f5" class="w200">备注</td>
          </tr>
          <tr v-for="(item, index) in ruleForm.jxrzxskqhejils" :key="index">
            <td bgcolor="#f4f4f5">{{index+1}}</td>
            <td>{{item.kqxm}}</td>
            <td v-for="(kqItem, kqInd) in kqlxData" :key="kqInd">
              <div class="gang_wei">
                <el-icon v-if="kqItem.id===item.kqmbid"><Select /></el-icon>
              </div>
            </td>
            <td v-for="(jlItem, jlInd) in jllxData" :key="jlInd">
              <div class="gang_wei">
                <span v-for="(jlVal, jlV) in item.jlmap" :key="jlV">
                  <el-icon v-if="jlItem.id===jlVal.jlmbids"><Select /></el-icon>
                </span>
              </div>
            </td>
            <td>{{item.kqbz}}</td>
          </tr>
          <tr>
            <td colspan="2" bgcolor="#ecf5ff">备注</td>
            <td :colspan="kqlxData.length+jllxData.length+1">{{ruleForm.bz}}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import {
  closeWindow,
  loadSelect,
  actionPost
} from '@/api/common.js'
import { getjxrzmbtx, getkclb, getZwxq, getKqlx } from '@/utils/meiju.js'
import { warningPrompt } from '@/utils/promptInfo.js'
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

const ruleForm = ref({})

const kqlxData = ref([]) // 考勤类型
const jllxData = ref([]) // 纪律类型
const lxData = ref(getjxrzmbtx()) // 类型
const xskqhz = ref([]) // 学生考勤汇总
const xsjlhz = ref([]) // 学生纪律汇总

const kclbData = ref(getkclb()) // 课程类别
// 获取日期
const huoQuRiQi = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: { xqid: ruleForm.value.xqid, xq: ruleForm.value.xq, zc: ruleForm.value.zc }
  }).then((res) => {
    if (res.code === 200) {
      ruleForm.value.rq = res.data[0].rq
    } else {
      warningPrompt(res.message)
    }
  })
}
// 学生考勤汇总数量
const initKaoQinHuiZong = () => {
  const arr = ruleForm.value.kqcount
  for (const i in arr) {
    const jian = i
    const zhi = arr[i].length
    xskqhz.value.forEach(item => {
      if (item.kqmbid === jian) {
        item.sl = zhi
      }
    })
  }
}
// 学生纪律汇总数量
const initJiLvHuiZong = () => {
  const arr = ruleForm.value.jlcount
  for (const i in arr) {
    const jian = i
    const zhi = arr[i].length
    xsjlhz.value.forEach(item => {
      if (item.jlmbid === jian) {
        item.sl = zhi
      }
    })
  }
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      // 考勤记录类型
      loadSelect({
        url: '/api/v2/jiaowu/kaoqinjilumuban/list',
        data: kqlxData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          kqlxData.value = []
          jllxData.value = []
          res.data.forEach((element) => {
            if (element.lx === getKqlx().kaoqin) {
              const obj = { kqmbid: element.id, sx: element.sx, sl: 0, xsids: [] }
              xskqhz.value.push(obj)
              kqlxData.value.push(element)
            }
            if (element.lx === getKqlx().jilv) {
              const obj = { jlmbid: element.id, sx: element.sx, sl: 0, jls: [] }
              xsjlhz.value.push(obj)
              jllxData.value.push(element)
            }
          })
        }
      })
      // 获取详情
      actionPost({
        url: '/api/v2/jiaowu/jiaoshijiaoxuerizhi/' + props.row.jxrzid,
        data: {}
      }).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
          ruleForm.value.xqmc = getZwxq(ruleForm.value.xq)
          // 授课方式
          kclbData.value.list.forEach((element) => {
            if (element.value === ruleForm.value.skxs) {
              ruleForm.value.skxsmc = element.name
            }
          })
          huoQuRiQi()
          initKaoQinHuiZong()
          initJiLvHuiZong()
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(td) {
  text-align: center;
  height: 35px;
  min-width: 50px;
}
.el-textarea__inner {
  min-height: 100%;
}
:deep(.select-trigger),
:deep(.el-input) {
  height: 100%;
}
:deep(.xue-sheng-kao-qin) {
  height: 50px;
  :deep(td) {
    height: 50px;
  }
}
:deep(.gang_wei .el-radio__label) {
  display: none;
}
:deep(.el-textarea__inner) {
  min-height: 100% !important;
  height: 100%;
}
</style>
